import LocalDatabase from '@/includes/db';
import { Schema } from '@/includes/definitions/index.d';
import { WordText } from '@/includes/definitions/word.d';

const schema = {
  name: 'Word',
  keyPath: 'id',
  autoIncrement: true,
  timestamps: true,
  schema: {
    id: { unique: true },
    text: { unique: false },
    meaning: { unique: false },
    type: { unique: false },
    gender: { unique: false },
    textLanguage: { unique: false },
    meaningLanguage: { unique: false },
  },
} as Schema;

export const WordsModel = LocalDatabase.MakeModel<WordText>(schema);
export default schema;
